import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { GetCountry, GetGenders, getTranslation, GetUserById, getUserModuleAPI, updatePagePermissionAPI } from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";


// Get Page Permission Data
export const fetchUserModule = createAsyncThunk(
  "module/fetchUserModule",
  async (module, thunkAPI) => {
    
    try {
      const response = await getUserModuleAPI(module); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Get Genders
export const fetchGenders = createAsyncThunk(
  "genders/fetchGenders",
  async (thunkAPI) => {
    try {
      const response = await GetGenders(); 
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Get Genders
export const fetchCountry = createAsyncThunk(
  "country/fetchCountry",
  async (thunkAPI) => {
    try {
      const response = await GetCountry(); 
      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Text translate 
export const fetchTranslation = createAsyncThunk(
  "text/fetchTranslation",
  async (text, thunkAPI) => {
    try {
      const response = await getTranslation(text); 
      
      return response.Data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);